import { FC } from 'react';

import { useEventListeners } from '../../hooks/use-event-listeners';
import { useGiveModal } from '../../hooks/use-give-modal';
import { useInitGiveRecognitionModal } from '../../hooks/use-init-give-recognition-modal';
import { GiveModal } from './give-modal';

type GlobalGiveBoxProps = {
	onSuccess?: () => void;
	via?: string;
};

export const GlobalGiveBox: FC<GlobalGiveBoxProps> = ({ onSuccess, ...props }) => {
	useEventListeners();
	useInitGiveRecognitionModal();
	const giveModal = useGiveModal({ onSuccess });

	return <GiveModal {...giveModal} {...props} />;
};
